export default __webpack_public_path__ + "static/media/fall.14313adc.png";